/*
 *
 * Students actions
 *
 */

import {
  FLUSH_STATE,
  LOAD_STUDENTS,
  LOAD_STUDENTS_SUCCESS,
  LOAD_STUDENTS_ERROR,
  UPDATE_STUDENT,
  UPDATE_STUDENT_SUCCESS,
  UPDATE_STUDENT_ERROR,
} from './constants';

export function flushState() {
  return {
    type: FLUSH_STATE,
  };
}

/**
 * Load the students, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_STUDENTS
 */
export function loadStudents() {
  return {
    type: LOAD_STUDENTS,
  };
}

/**
 * Dispatched when the loadStudents are loaded by the request saga
 *
 * @param  {array} variables true for students
 *
 * @return {object} An action object with a type of LOAD_STUDENTS_SUCCESS passing the variables
 */
export function loadStudentsSuccess(itemsList, firstElem) {
  return {
    type: LOAD_STUDENTS_SUCCESS,
    itemsList,
    firstElem,
  };
}

/**
 * Dispatched when loading the loadStudents fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of LOAD_STUDENTS_ERROR passing the error
 */
export function loadStudentsError(error) {
  return {
    type: LOAD_STUDENTS_ERROR,
    error,
  };
}

// Update for Single User
export function updateStydent(studentDetail) {
  return {
    type: UPDATE_STUDENT,
    studentDetail,
  };
}
export function updateStydentSuccess(studentDetail) {
  return {
    type: UPDATE_STUDENT_SUCCESS,
    studentDetail
  };
}

export function updateStydentError(error) {
  return {
    type: UPDATE_STUDENT_ERROR,
    error,
  };
}
